// extracted by mini-css-extract-plugin
export var border = "Headline-module--border--5056f";
export var headline = "Headline-module--headline--408e4";
export var label = "Headline-module--label--d2543";
export var title = "Headline-module--title--fb528";